// Country prefixes for the masterclass phone form.
// Ordered by prevalence in the Spanish-speaking market first, then EU + US, then rest.
export const COUNTRY_PREFIXES = [
  { code: "+34", country: "España", flag: "🇪🇸" },
  { code: "+52", country: "México", flag: "🇲🇽" },
  { code: "+54", country: "Argentina", flag: "🇦🇷" },
  { code: "+57", country: "Colombia", flag: "🇨🇴" },
  { code: "+56", country: "Chile", flag: "🇨🇱" },
  { code: "+51", country: "Perú", flag: "🇵🇪" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+593", country: "Ecuador", flag: "🇪🇨" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+591", country: "Bolivia", flag: "🇧🇴" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+507", country: "Panamá", flag: "🇵🇦" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+1-do", country: "Rep. Dominicana", flag: "🇩🇴", dial: "+1" },
  { code: "+1-pr", country: "Puerto Rico", flag: "🇵🇷", dial: "+1" },
  { code: "+1-us", country: "Estados Unidos", flag: "🇺🇸", dial: "+1" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+33", country: "Francia", flag: "🇫🇷" },
  { code: "+49", country: "Alemania", flag: "🇩🇪" },
  { code: "+44", country: "Reino Unido", flag: "🇬🇧" },
  { code: "+39", country: "Italia", flag: "🇮🇹" },
  { code: "+376", country: "Andorra", flag: "🇦🇩" },
  { code: "+41", country: "Suiza", flag: "🇨🇭" },
  { code: "+31", country: "Países Bajos", flag: "🇳🇱" },
  { code: "+32", country: "Bélgica", flag: "🇧🇪" },
  { code: "+353", country: "Irlanda", flag: "🇮🇪" },
  { code: "+43", country: "Austria", flag: "🇦🇹" },
  { code: "+45", country: "Dinamarca", flag: "🇩🇰" },
  { code: "+46", country: "Suecia", flag: "🇸🇪" },
  { code: "+47", country: "Noruega", flag: "🇳🇴" },
  { code: "+358", country: "Finlandia", flag: "🇫🇮" },
  { code: "+30", country: "Grecia", flag: "🇬🇷" },
  { code: "+48", country: "Polonia", flag: "🇵🇱" },
  { code: "+55", country: "Brasil", flag: "🇧🇷" },
  { code: "+972", country: "Israel", flag: "🇮🇱" },
  { code: "+971", country: "Emiratos Árabes", flag: "🇦🇪" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+64", country: "Nueva Zelanda", flag: "🇳🇿" },
];

// Given a prefix key (e.g. "+1-us"), return the actual dial value to send ("+1").
export function toDialCode(key) {
  const p = COUNTRY_PREFIXES.find((c) => c.code === key);
  if (!p) return key;
  return p.dial || p.code;
}
